import React from "react";
import ReactDOM from "react-dom";
import "./index.css"
import Pages from "./pages/Pages";
import { BrowserRouter } from "react-router-dom";

function App() {
  return (
    
      <BrowserRouter>
        <Pages />
      </BrowserRouter>
   
  );
}

document.title = "CAWIL.ai Data Platform";
ReactDOM.render(<App />, document.getElementById("root"));
